'use strict';
module.exports = require('./PrimeVue.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/config/index.js
// module id = 509
// module chunks = 0